// initial state	
export default () => ({
	empresas: [],
	selected: undefined,
	isloading: false,
	isloadingSucursales: false,
	estadosDTE: [],
});